import React from 'react';
import { Alert } from '@planne-software/uni';
import { uni } from '@planne-software/uni/v2';
import { IconInfoCircle } from '@tabler/icons-react';

import { useTranslate } from '@src/core/hooks';

type ForeignBuyerAlertProps = {
  visible: boolean;
};

export const ForeignBuyerAlert = (props: ForeignBuyerAlertProps) => {
  const { visible } = props;
  const { i18n } = useTranslate();

  if (!visible) {
    return null;
  }

  return (
    <Alert
      data-testid='card-form-foreign-alert'
      severity='info'
      canClose={false}
      title={i18n('checkout_payment_card_foreign_alert_title')}
      subTitle={i18n('checkout_payment_card_foreign_alert_description')}
      startIcon={<IconInfoCircle size={20} aria-hidden />}
      sx={{ marginTop: 0, width: '100%', marginBottom: uni('scale-200') }}
    />
  );
};

export default ForeignBuyerAlert;
